import React from 'react';
import { Send, Search, ChevronDown } from 'lucide-react';
import { YEARS } from '../config/feedbackConfig';

interface FilterBarProps {
  filterYear: string;
  onYearChange: (year: string) => void;
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  resultCount: number;
  onNewRequest?: () => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  filterYear,
  onYearChange,
  searchQuery,
  onSearchChange,
  resultCount,
  onNewRequest
}) => {
  return (
    <div className="bg-white rounded-2xl p-5 mb-6 shadow-sm border border-slate-200">
      <div className="flex items-center gap-4 flex-wrap">
        {onSearchChange !== undefined && (
          <div className="relative flex-1 min-w-[250px] max-w-[400px]">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input
              type="text"
              value={searchQuery || ''}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search connect name..."
              className="w-full bg-slate-50 text-slate-800 border border-slate-200 rounded-xl pl-10 pr-4 py-2.5 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-pink-500/20 focus:border-pink-300 transition-all placeholder:text-slate-400"
            />
          </div>
        )}

        <div className="ml-auto flex items-center gap-4">
          <div className="relative inline-flex items-center">
            <select
              value={filterYear}
              onChange={(e) => onYearChange(e.target.value)}
              className="bg-slate-50 text-slate-800 border border-slate-200 rounded-xl pl-4 pr-9 py-2.5 text-sm font-medium appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-pink-500/20 focus:border-pink-300 transition-all"
            >
              <option value="all">All Years</option>
              {YEARS.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
            <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
          </div>
          
          <span className="text-sm font-medium text-slate-500">
            {resultCount} {resultCount === 1 ? 'Request' : 'Requests'}
          </span>
          
          {onNewRequest && (
            <button
              onClick={onNewRequest}
              className="bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white px-5 py-2.5 rounded-xl font-medium text-sm flex items-center gap-2 shadow-sm shadow-pink-500/20 hover:shadow-md hover:shadow-pink-500/25 transition-all"
            >
              <Send className="w-4 h-4" />
              New Connect
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
